function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './numberPicker.scss';
export default function NumberPicker(_ref) {
  var id = _ref.id,
      value = _ref.value,
      inputName = _ref.inputName,
      onChange = _ref.onChange,
      downAriaLabel = _ref.downAriaLabel,
      upAriaLabel = _ref.upAriaLabel,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 1 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 99 : _ref$max,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  useEffect(function () {
    setCurrentValue(value);
  }, [value]);

  function handleBlur() {
    if (value !== currentValue) {
      propagateChange(currentValue);
    }
  }

  function handleChange(evt) {
    setCurrentValue(evt.target.value);
  }

  function handleKeyDown(evt) {
    if (evt.keyCode === 13) {
      evt.preventDefault();
      evt.stopPropagation();
      handleChange(evt);
      handleBlur();
      return false;
    }

    return true;
  }

  function handleUpDown(direction) {
    return function (evt) {
      evt.preventDefault();

      if (disabled) {
        return;
      }

      if (onChange) {
        var base = parseInt(currentValue, 10) || 0;
        var increment = direction === 'up' ? 1 : -1;
        propagateChange(base + increment);
      }
    };
  }

  function propagateChange(newValue) {
    if (!onChange) {
      return;
    }

    if (newValue === '' || isNaN(newValue)) {
      setCurrentValue(value);
    } else if (newValue < min) {
      setCurrentValue(min);
      onChange(min);
    } else if (newValue > max) {
      setCurrentValue(max);
      onChange(max);
    } else {
      onChange(newValue);
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "bt-numberPicker"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bt-numberPicker__upDown bt-numberPicker__upDown--down"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleUpDown('down'),
    "aria-label": downAriaLabel
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-minus-circle"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "bt-numberPicker__input"
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    name: inputName,
    type: "number",
    value: currentValue,
    onBlur: handleBlur,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    autoComplete: "off",
    min: min,
    max: max,
    pattern: "[0-9]*"
  })), /*#__PURE__*/React.createElement("div", {
    className: "bt-numberPicker__upDown bt-numberPicker__upDown--up"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleUpDown('up'),
    "aria-label": upAriaLabel
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus-circle"
  }))));
}
NumberPicker.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  inputName: PropTypes.string,
  onChange: PropTypes.func,
  downAriaLabel: PropTypes.string,
  upAriaLabel: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  disabled: PropTypes.bool
};